import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgTopbarArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 13 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 .505h1.753A4 4 0 0 1 5.486 3.07L12 20.005 5.486 36.941a4 4 0 0 1-3.733 2.564H0"
      stroke="#007AFF"
    />
  </svg>
);
const Memo = memo(SvgTopbarArrow);
export default Memo;
